import { useEffect, useState } from 'react'

import { PhnxButton } from '@/components/01-atoms/Button/Button'

import { TabItem } from './Blok'
import styles from './TabGroup.module.css'

export type TabGroupProps = {
  tabs: TabItem[]
  itemsPerPage?: number
  viewMoreLabel?: string
}

export const PhnxTabGroup: React.FC<TabGroupProps> = ({
  tabs,
  itemsPerPage = 5,
  // viewMoreLabel = 'View More',
}) => {
  const [activeTab, setActiveTab] = useState(tabs[0]?.name)
  const [visibleItems, setVisibleItems] = useState(itemsPerPage)

  const onTabClick = (tab: string) => {
    setActiveTab(tab)
    setVisibleItems(itemsPerPage)
  }

  const onTabKeyDown = (event: React.KeyboardEvent<HTMLButtonElement>, tab: string) => {
    if (event.key === 'Enter') {
      onTabClick(tab)
    }
  }

  const handleViewMore = () => {
    setVisibleItems((prev) => prev + itemsPerPage)
  }

  useEffect(() => {
    setActiveTab(tabs[0]?.name)
    setVisibleItems(itemsPerPage)
  }, [tabs, itemsPerPage])

  return (
    <div className={styles['tab-group']}>
      <div className={styles['tab-buttons']}>
        {tabs.map((tab, index) => (
          <button
            key={tab.name}
            onClick={() => onTabClick(tab.name)}
            onKeyDown={(e) => onTabKeyDown(e, tab.name)}
            className={`${styles['tab']} ${tab.name === activeTab ? styles['tab-active'] : ''}`.trim()}
            aria-controls={`tab${index}-panel`}
          >
            {tab.name}
          </button>
        ))}
      </div>

      {tabs.map((tab, index) => {
        const activeTabContent = Array.isArray(tab.content) ? tab.content : [tab.content]
        const hasMoreItems = activeTabContent.length > visibleItems

        return (
          <div
            role="tabpanel"
            id={`tab${index}-panel`}
            key={tab.name}
            className={`${styles['tab-content']} ${activeTab === tab.name ? '!block' : ''}`.trim()}
            aria-label={tab.name}
          >
            {activeTabContent.slice(0, visibleItems)}

            {hasMoreItems && activeTab === tab.name && (
              <PhnxButton
                label="View more advisors"
                type="button"
                onClick={handleViewMore}
                className={styles['view-more']}
              />
            )}
          </div>
        )
      })}
    </div>
  )
}
